// fill="${color ? color : "currentColor"}"
// width=${width}
// height=${height}
// currentColor ใส่เเทนสี ที่ต้องการเปลี่ยน สีตาม  ConfigProvider theme
import PropTypes from 'prop-types'

import React from 'react'

const Index = ({ width = 16, height = 16, color }) => {
  const svgXml = `
    <svg
      width=${width}
      height=${height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7016 4.98772L15.5119 0.798975C15.1603 0.447466 14.6834 0.25 14.1863 0.25C13.6891 0.25 13.2122 0.447466 12.8606 0.798975L1.29938 12.3593C1.12468 12.5329 0.986159 12.7395 0.891857 12.967C0.797554 13.1946 0.74934 13.4386 0.750007 13.6849V17.8746C0.750007 18.3719 0.947551 18.8488 1.29918 19.2004C1.65081 19.5521 2.12773 19.7496 2.62501 19.7496H18.375C18.6734 19.7496 18.9595 19.6311 19.1705 19.4201C19.3815 19.2091 19.5 18.923 19.5 18.6246C19.5 18.3262 19.3815 18.0401 19.1705 17.8291C18.9595 17.6181 18.6734 17.4996 18.375 17.4996H9.84376L19.7016 7.63991C19.8758 7.46579 20.0139 7.25906 20.1082 7.03152C20.2025 6.80399 20.251 6.56011 20.251 6.31382C20.251 6.06753 20.2025 5.82365 20.1082 5.59611C20.0139 5.36858 19.8758 5.16184 19.7016 4.98772ZM6.65626 17.4996H3.00001V13.8433L10.875 5.96835L14.5313 9.6246L6.65626 17.4996ZM16.125 8.03085L12.4688 4.3746L14.1881 2.65522L17.8444 6.31147L16.125 8.03085Z"
        fill="${color ? color : 'currentColor'}"
      />
    </svg>
   `

  return (
    <div
      style={{ display: 'flex', alignItems: 'center' }}
      dangerouslySetInnerHTML={{ __html: svgXml }}
    />
  )
}
Index.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}
export default Index
